import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button, FullModal } from '@sbt-web/ui';
export const AiDisclaimer = () => {
  const $ = _c(7);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button design="text" size="small" onClick={() => setIsOpen(true)} icon={<img src="/static/img/ui/info.svg" height={16} width={16} alt="" loading="lazy" decoding="async" />} aria-label={"Pi\xF9 dettagli sulle domande frequenti"} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [<Button key="closer" design="solid" onClick={() => setIsOpen(false)}>Ok, ho capito</Button>];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <a href="https://info.subito.it/policies/condizioni-generali.htm">clicca qui</a>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p>Il contenuto di questa sezione è generato automaticamente tramite intelligenza artificiale generativa supportata da Amazon Bedrock. Per ulteriori informazioni sul suo funzionamento,{" "}{t3}. Il contenuto generato potrebbe essere impreciso, offensivo, di parte o tendenzioso e non rappresenta l'opinione di Subito.it. È necessario verificare tali contenuti ed essere cauti nel loro utilizzo o nel farvi affidamento. Se desideri segnalare qualsiasi problema relativo al contenuto generato dall'IA,{" "}<a href="https://assistenza.subito.it/hc/it/requests/new">clicca qui.</a></p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOpen) {
    t5 = <>{t0}<FullModal open={isOpen} title="Contenuto generato dall'IA" onClose={t1} actions={t2}>{t4}</FullModal></>;
    $[5] = isOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};